// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c92962a1","455":"3b7993c5","977":"32492528"}[chunkId] + ".chunk.js";
};